<template>
  <div class="topBanner">
    <div class="logo">{{$store.state.ticketDetail.ticketName}}</div>
    <div class="user" v-if="$cookie.get('ticket_phone')">
      <div>{{$cookie.get('ticket_phone')}}</div>
      <div class="logoOut" @click="logoOut">退出</div>
    </div>
    <div class="topIcon"></div>
    <div class="bottomIcon"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      museumName: ''
    };
  },

  methods: {
    logoOut() {
      this.$cookie.delete('token')
      location.href = `http://passport2.chaoxing.com/logout.html?refer=${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`
    },

    toIndex() {
      this.$router.replace(`/ticket/home?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
    }
  }
}
</script>

<style scoped lang="scss">
.topBanner{
  height: 100px;
  position: relative;
  .topIcon, .bottomIcon{
    position: fixed;
    height: 400px;
    width: 250px;
    z-index: -1;
  }
  .topIcon{
    right: 0;
    top: 100px;
    background: url('../../assets/ticket/right_top.png') 0 0/cover no-repeat;
  }
  .bottomIcon{
    left: 0;
    bottom: 0;
    background: url('../../assets/ticket/left_bottom.png') 0 0/cover no-repeat;
  }
  .logo{
    position: absolute;
    height: 50px;
    top: 30px;
    left: 10%;
    cursor: pointer;
    font-family: DNXSJW;
    font-size: 50px;
  }
  div{
    font-size: 18px;
    color: #fff;
    height: 33px;
    line-height: 33px;
  }
  .user{
    top: 33px;
    right: 10%;
    position: absolute;
    padding-left: 0.3rem;
    &::before{
      height: 0.11rem;
      width: 0.1rem;
      background: url('../../assets/ticket/icon_person.png') 0 0/100% no-repeat;
      content: '';
      display: inline-block;
      margin-right: 0.05rem;
    }
    .logoOut{
      margin-left: 0.3rem;
      cursor: pointer;
    }
    div{
      display: inline-block;
    }
  }
  
}
</style>
